import * as React from 'react';
import { Block } from '@/presentation/components';
import Step from '../../../UpdatePhoto/Register/components/Step';
import Select from '../../../../scholarships/bse/components/Select';
import Button from '@/presentation/reusables/Button';
import InputText from '../../../../scholarships/bse/components/InputText';

interface StepsProps {
  steps: any;
  documents: any[];
  selectedDocument: any;
  selectedDocumentFields: any[];
  formIsOk: boolean;
  handlerChangeDocument: (value: any) => void;
  setSelectedDocumentFields: (key: string, value: string) => void;
  handlerErrors: (key: string, value: boolean) => void;
  handlerRegister: () => void;
}
const Steps = ({
  steps,
  documents,
  selectedDocument,
  selectedDocumentFields,
  formIsOk,
  handlerChangeDocument,
  setSelectedDocumentFields,
  handlerErrors,
  handlerRegister
}: StepsProps) => (
  <Block customized padding="28px 0px 45px 8px">
    <Step
      name={steps[0]?.name}
      order={steps[0]?.order}
      isCurrent
      isComplete={false}
    >
      <Block
        customized
        padding="24px"
        backgroundColor="#fff"
        borderRadius="4px"
        margin="16px 0px 32px 0px"
      >
        <span style={{ marginBottom: 4 }}>Tipo de carta</span>
        <Select
          placeholder="Selecciona"
          value={selectedDocument}
          setFieldValue={(e) => {
            if (e.value) handlerChangeDocument(e.value);
          }}
          optionsList={documents}
          nameLabel={''}
          name="description"
          validateForm={0}
        />

        {selectedDocument && selectedDocumentFields && (
          <>
            {Object.keys(selectedDocumentFields).map((field: any, index) => (
              <div style={{ width: '100%' }} key={`${index + 1}-element`}>
                <span style={{ marginBottom: 4, display: 'block' }}>
                  {selectedDocumentFields[field].title}
                </span>
                <InputText
                  value={selectedDocumentFields[field].value}
                  placeholder={selectedDocumentFields[field].placeholder}
                  setFieldValue={(e) => {
                    setSelectedDocumentFields(field, e.value);
                  }}
                  name={field}
                  validateForm={0}
                  setFieldError={(e) => {
                    handlerErrors(field, e.value);
                  }}
                  maxLength={selectedDocumentFields[field].length}
                  onlyNumbers={selectedDocumentFields[field].isNumeric}
                  customValidation={
                    selectedDocumentFields[field].customValidate
                  }
                />
              </div>
            ))}
          </>
        )}

        <Button
          text="Solicitar"
          disabled={!formIsOk}
          style={{ marginTop: 16 }}
          onClick={handlerRegister}
        />
      </Block>
    </Step>

    <Step name={steps[1]?.name} order={steps[1]?.order} isLast disabled />
  </Block>
);

export default Steps;
